 $(document).ready(function () {
    const $carousel = $('.video-blocks');
    const $items = $('.video-wrapper');
    // 获取所有视频元素
    const $videos = $('.video-wrapper video');
    const cardWidth = $items.outerWidth();
    const pauseSvg =
      '<svg xmlns="http://www.w3.org/2000/svg" aria-label="Play" class=""><path d="m8 6 16 10.5L8 26V6Z"></path></svg>';
    const playSvg =
      '<svg xmlns="http://www.w3.org/2000/svg" aria-label="Pause" class=""><path d="M8 6h6v20H8V6Zm10 0h6v20h-6V6Z"></path></svg>';
    const MuteSvg =
      '<svg xmlns="http://www.w3.org/2000/svg" aria-label="SoundOn" class=""><path d="M23 4h4v24h-4V4Zm-6 5.33h4V28h-4V9.33Zm-6 5.34h4V28h-4V14.67ZM5 20h4v8H5v-8Z"></path></svg>';
    const UnMuteSvg =
      '<svg xmlns="http://www.w3.org/2000/svg" aria-label="SoundOff" class=""><path d="M5 24h4v4H5v-4Zm6 0h4v4h-4v-4Zm6 0h4v4h-4v-4Zm6 0h4v4h-4v-4Z"></path></svg>';

    // 视口检测动画
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('in-view');

            // 设置每个视频项的动画延迟
            // 初始化动画
            $items.each(function (index) {
              $(this).css({
                'animation-delay': index * 0.1 + 's',
                'animation-fill-mode': 'forwards',
              });
              setTimeout(() => {
                $(this).addClass('animate');
              }, index * 100);
            });
          }
        });
      },
      { threshold: 0.1 }
    );

    document.querySelectorAll('.video-blocks').forEach((section) => {
      observer.observe(section);
    });
    // 轮播导航
    $(document).on('click', '.prev', function () {
      $carousel.animate({ scrollLeft: `-=${cardWidth}` }, 300);
    });
    $(document).on('click', '.next', function () {
      $carousel.animate({ scrollLeft: `+=${cardWidth}` }, 300);
    });
    // 页面加载时检查
    checkViewport();
    // 窗口大小改变时检查
    $(window).resize(function () {
      checkViewport();
    });
    // 初始化所有视频状态
    $videos.each(function () {
      this.pause(); // 确保所有视频初始暂停
      $(this).attr('paused', true);
      const video = this;
      const wrapper = $(this).closest('.video-wrapper');
      const playPauseBtn = wrapper.find('.play-btn');
      const muteBtn = wrapper.find('.mute-btn');
      const fullscreenBtn = wrapper.find('.full-btn');
      const progressBar = wrapper.find('.progress_bar');
      // 播放/暂停
      playPauseBtn.click(function () {
        playPauseBtn.empty();
        if (video.paused) {
          video.play();
          playPauseBtn.append(playSvg);
        } else {
          video.pause();
          playPauseBtn.append(pauseSvg);
        }
      });
      // 静音/取消静音
      muteBtn.click(function (event) {
        event.stopPropagation();
        video.muted = !video.muted;
        muteBtn.empty();
        muteBtn.append(video.muted ? UnMuteSvg : MuteSvg);
      });
      // 全屏
      fullscreenBtn.click(function (event) {
        event.stopPropagation();
        fullscreen(video);
      });
      // 进度条更新
      video.addEventListener('timeupdate', function () {
        const percent = (video.currentTime / video.duration) * 100;
        progressBar.css('width', percent + '%');
        if (percent == 100) {
          playPauseBtn.empty();
          playPauseBtn.append(pauseSvg);
          progressBar.css('width', '0%');
          $(video).attr('paused', true);
          wrapper.find('.control-block-mobile').css('display', 'block');
        }
      });
    });
    // 为每个视频添加点击事件
    $videos.on('play', function () {
      // 暂停其他所有视频
      $videos.not(this).each(function () {
        this.pause();
      });
    });
    // 点击视频区域暂停视频/播放
    $items.click(function () {
      const $video = $(this).find('video')[0];
      let isPaused = $(this).find('video').attr('paused');
      if (!isPaused) {
        $video.pause();
        $(this).find('video').attr('paused', true);
        $(this).find('.play-btn').empty();
        $(this).find('.play-btn').append(pauseSvg);
        $(this).find('.control-block-mobile').css('display', 'block');
      } else {
        // 暂停其他所有视频
        $videos.not(this).each(function () {
          this.pause();
          $(this).attr('paused', true);
          $(this).closest('.video-wrapper').find('.play-btn').empty();
          $(this).closest('.video-wrapper').find('.play-btn').append(pauseSvg);
          $(this).closest('.video-wrapper').find('.control-block-mobile').css('display', 'block');
        });
        $(this).find('video').attr('paused', '');
        $video.play();
        $(this).find('.play-btn').empty();
        $(this).find('.play-btn').append(playSvg);
        $(this).closest('.video-wrapper').find('.control-block-mobile').css('display', 'none');
      }
    });
    // 双击全屏
    $videos.dblclick(function () {
      fullscreen(this);
    });
    function fullscreen(dom) {
      if (!document.fullscreenElement) {
        if (dom.requestFullscreen) {
          dom.requestFullscreen();
        } else if (dom.webkitRequestFullscreen) {
          dom.webkitRequestFullscreen();
        }
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen();
        }
      }
    }
    function checkViewport() {
      if ($(window).width() < 768) {
        // 移除所有hover效果
        $items.off('mouseenter mouseleave');
        $items.css({
          transform: '',
        });
      } else {
        // 重新绑定hover效果
        $items.hover(
          function () {
            $(this).css({
              transform: 'scale(1.05) translateY(-5px)',
            });
            $(this).find('.control-block').css('opacity', '1');
          },
          function () {
            $(this).css({
              transform: 'scale(1) translateY(0px)',
            });
            $(this).find('.control-block').css('opacity', '0');
          }
        );
      }
    }
  });